import React from 'react';

const GroundData = () => {
    return null;
}

export default GroundData;